// campCoords.js — AUTO-GENERATED by scripts/geocode-camps.mjs
// Do not edit by hand. Re-run the script after adding camps to data.js.
// Source: postcodes.io (Ordnance Survey / ONS open data)
// Generated: 2026-07-14
// 627 full postcodes · 67 outward codes

export const POSTCODE_COORDS = {
  "E107QL": [51.56551, -0.03873],
  "E28QA": [51.53203, -0.06662],
  "E81EJ": [51.54607, -0.05547],
  "E83EU": [51.54306, -0.06249],
  "EN40EL": [51.66858, -0.17552],
  "EN40JY": [51.65677, -0.1532],
  "EN40NJ": [51.66345, -0.18779],
  "EN40PS": [51.65731, -0.13758],
  "EN51JP": [51.64141, -0.18037],
  "EN52AG": [51.63842, -0.22859],
  "EN52DN": [51.64562, -0.19304],
  "EN52ED": [51.64883, -0.1947],
  "EN52EU": [51.64779, -0.19875],
  "EN54BE": [51.65282, -0.20247],
  "EN54BW": [51.65331, -0.20483],
  "EN54DQ": [51.65586, -0.21333],
  "EN54HL": [51.65713, -0.20816],
  "EN54NP": [51.65724, -0.21328],
  "EN54NR": [51.65681, -0.21179],
  "EN54QN": [51.66451, -0.20018],
  "EN55HT": [51.65352, -0.17678],
  "EN55RR": [51.65182, -0.19668],
  "EN55SG": [51.65335, -0.19486],
  "EN55SJ": [51.65303, -0.19932],
  "EN55SU": [51.65781, -0.20147],
  "KT11BW": [51.40982, -0.30289],
  "KT11EU": [51.40772, -0.30592],
  "KT11HL": [51.40817, -0.30773],
  "KT11JP": [51.41007, -0.30629],
  "KT11JS": [51.40981, -0.30624],
  "KT11NX": [51.4108, -0.30439],
  "KT11ST": [51.41138, -0.30204],
  "KT11TP": [51.41156, -0.30487],
  "KT13PB": [51.40601, -0.28136],
  "KT14AU": [51.41457, -0.31422],
  "KT14AZ": [51.41205, -0.31722],
  "KT14DA": [51.4122, -0.31107],
  "KT14HQ": [51.41591, -0.30999],
  "KT25BH": [51.42688, -0.30922],
  "KT25PL": [51.42557, -0.30291],
  "KT26PY": [51.41006, -0.29644],
  "KT26QJ": [51.4106, -0.29277],
  "KT26RL": [51.41177, -0.2956],
  "KT27DY": [51.41841, -0.25682],
  "KT27NU": [51.41811, -0.27372],
  "KT33PB": [51.39992, -0.26171],
  "KT34BY": [51.40255, -0.25669],
  "KT34DQ": [51.40312, -0.25715],
  "KT34HG": [51.40357, -0.25628],
  "KT34PH": [51.40107, -0.24283],
  "KT34TA": [51.39956, -0.25294],
  "KT35AL": [51.39606, -0.26003],
  "KT35AS": [51.39779, -0.2633],
  "KT36JF": [51.39489, -0.23821],
  "KT36NU": [51.39508, -0.24769],
  "KT58AB": [51.39719, -0.29778],
  "KT58JT": [51.39366, -0.29005],
  "KT64AL": [51.39499, -0.3069],
  "KT64JT": [51.39207, -0.30733],
  "KT64LQ": [51.39367, -0.30368],
  "KT64NG": [51.39114, -0.30845],
  "KT64QG": [51.39413, -0.30658],
  "KT64QH": [51.39337, -0.30553],
  "KT66RL": [51.38029, -0.30548],
  "KT67PB": [51.37728, -0.28735],
  "KT70QG": [51.39284, -0.33261],
  "KT92NE": [51.3486, -0.31476],
  "N101BN": [51.59454, -0.15379],
  "N101HS": [51.59711, -0.15301],
  "N101JS": [51.60258, -0.1531],
  "N101NE": [51.59278, -0.1509],
  "N101NR": [51.59512, -0.15259],
  "N101PS": [51.59443, -0.14959],
  "N102NL": [51.60488, -0.14404],
  "N102PT": [51.59196, -0.14065],
  "N103EF": [51.59124, -0.15254],
  "N103HL": [51.58989, -0.14472],
  "N103HP": [51.59005, -0.14677],
  "N103JA": [51.58723, -0.14845],
  "N103NU": [51.59186, -0.14789],
  "N103PU": [51.58779, -0.13794],
  "N103QJ": [51.58945, -0.14182],
  "N103QR": [51.58975, -0.14406],
  "N103SH": [51.59086, -0.14213],
  "N103ST": [51.59102, -0.1411],
  "N111HJ": [51.62059, -0.14863],
  "N111RW": [51.61467, -0.13779],
  "N112AZ": [51.60215, -0.13624],
  "N112DD": [51.60919, -0.12177],
  "N113DS": [51.61354, -0.15342],
  "N11TA": [51.53945, -0.10396],
  "N120BP": [51.6137, -0.17634],
  "N120EQ": [51.61282, -0.17671],
  "N120GA": [51.61282, -0.17671],
  "N120GL": [51.60478, -0.17336],
  "N120PD": [51.60592, -0.17273],
  "N120RF": [51.60809, -0.16361],
  "N128LY": [51.61286, -0.17784],
  "N128PE": [51.60979, -0.18389],
  "N128QA": [51.61885, -0.17723],
  "N128RP": [51.61757, -0.17829],
  "N129EY": [51.61148, -0.16877],
  "N12DN": [51.53902, -0.10127],
  "N12GG": [51.54253, -0.10116],
  "N12NS": [51.54482, -0.09722],
  "N12QH": [51.54644, -0.08756],
  "N12TX": [51.53841, -0.10198],
  "N12UD": [51.54171, -0.10215],
  "N12UN": [51.54427, -0.10272],
  "N134EY": [51.61559, -0.1106],
  "N134PN": [51.61822, -0.11037],
  "N144PE": [51.64457, -0.14482],
  "N145DU": [51.63088, -0.14756],
  "N145HJ": [51.63638, -0.13553],
  "N145RJ": [51.63268, -0.13613],
  "N146AF": [51.63526, -0.1225],
  "N146BN": [51.63126, -0.12734],
  "N146QB": [51.63889, -0.12249],
  "N146RA": [51.6322, -0.11762],
  "N147JN": [51.62403, -0.13135],
  "N14DY": [51.54583, -0.0821],
  "N154RX": [51.58719, -0.07222],
  "N15EW": [51.53726, -0.0787],
  "N15JD": [51.53378, -0.08065],
  "N15JU": [51.53547, -0.08345],
  "N15LS": [51.53479, -0.07957],
  "N15PH": [51.53721, -0.08477],
  "N15SF": [51.53896, -0.08161],
  "N15SR": [51.53777, -0.08329],
  "N160LH": [51.56275, -0.0739],
  "N168AZ": [51.54872, -0.07647],
  "N168BZ": [51.55416, -0.07844],
  "N169ES": [51.56063, -0.08422],
  "N169EX": [51.55789, -0.08458],
  "N169HJ": [51.5612, -0.08625],
  "N16NU": [51.52778, -0.0818],
  "N18HX": [51.53656, -0.10073],
  "N18JX": [51.53236, -0.09919],
  "N18PQ": [51.53595, -0.09783],
  "N19PD": [51.53263, -0.10776],
  "N1C4AA": [51.53614, -0.12492],
  "N1C4PW": [51.53558, -0.12771],
  "N200DZ": [51.62448, -0.15985],
  "N200NL": [51.62166, -0.16557],
  "N200NQ": [51.62743, -0.17018],
  "N200PT": [51.62573, -0.1763],
  "N208AZ": [51.63885, -0.20034],
  "N208QL": [51.63278, -0.18163],
  "N209EZ": [51.6296, -0.16901],
  "N209HR": [51.63198, -0.17588],
  "N20BT": [51.58129, -0.15948],
  "N20QN": [51.57955, -0.17558],
  "N20QZ": [51.5907, -0.1676],
  "N20SE": [51.59111, -0.18709],
  "N211BG": [51.63553, -0.10309],
  "N212SJ": [51.63273, -0.09412],
  "N213AJ": [51.62859, -0.10218],
  "N213AP": [51.62841, -0.09842],
  "N213HE": [51.62944, -0.09434],
  "N225HJ": [51.603, -0.11024],
  "N225QH": [51.60338, -0.09701],
  "N225QW": [51.60466, -0.10003],
  "N226LH": [51.59605, -0.10195],
  "N226UJ": [51.59455, -0.11303],
  "N226XJ": [51.59463, -0.1147],
  "N227AY": [51.59448, -0.1305],
  "N227ST": [51.59764, -0.11927],
  "N227SZ": [51.59705, -0.1145],
  "N227TB": [51.59705, -0.11196],
  "N227UT": [51.60076, -0.13702],
  "N227XL": [51.60051, -0.13395],
  "N228HE": [51.59934, -0.1128],
  "N228HQ": [51.59737, -0.11057],
  "N28AU": [51.58942, -0.16472],
  "N28DA": [51.59145, -0.16761],
  "N28GA": [51.59145, -0.1692],
  "N28JN": [51.59413, -0.17363],
  "N29BE": [51.59372, -0.16738],
  "N29EB": [51.58989, -0.16376],
  "N29ED": [51.59086, -0.16437],
  "N29JP": [51.59484, -0.16819],
  "N31AR": [51.61037, -0.19419],
  "N31NB": [51.6071, -0.18573],
  "N31NT": [51.60926, -0.18889],
  "N31TD": [51.60169, -0.20409],
  "N31TT": [51.5988, -0.19905],
  "N31XP": [51.60339, -0.19132],
  "N31YN": [51.6081, -0.18846],
  "N32LN": [51.60023, -0.19467],
  "N32SY": [51.59528, -0.18933],
  "N32TA": [51.59479, -0.18612],
  "N33QE": [51.59687, -0.19623],
  "N42BN": [51.56254, -0.09244],
  "N42DR": [51.56213, -0.10069],
  "N42RH": [51.5732, -0.08407],
  "N42TG": [51.57071, -0.09462],
  "N43QW": [51.56688, -0.11393],
  "N51AR": [51.5528, -0.1015],
  "N51BU": [51.55667, -0.10634],
  "N51LP": [51.55855, -0.10543],
  "N51RR": [51.549, -0.1058],
  "N52DP": [51.55394, -0.09185],
  "N52EQ": [51.549, -0.09778],
  "N64AH": [51.57773, -0.16034],
  "N64AY": [51.57204, -0.14942],
  "N64BG": [51.57364, -0.15093],
  "N64ED": [51.57985, -0.15502],
  "N64NY": [51.57423, -0.15796],
  "N64PH": [51.57391, -0.15597],
  "N65AA": [51.57711, -0.14637],
  "N65BB": [51.57276, -0.14008],
  "N65BS": [51.57578, -0.14361],
  "N65HF": [51.57046, -0.14313],
  "N65HG": [51.5693, -0.14335],
  "N65HX": [51.57096, -0.14802],
  "N65JG": [51.57064, -0.14655],
  "N65JW": [51.57089, -0.14626],
  "N65UA": [51.57765, -0.14691],
  "N66BA": [51.57096, -0.14922],
  "N70ND": [51.55627, -0.12529],
  "N70SL": [51.55472, -0.12097],
  "N77NY": [51.55894, -0.11157],
  "N78DB": [51.55147, -0.11035],
  "N79PL": [51.54666, -0.11893],
  "N87RX": [51.59042, -0.11617],
  "N88DN": [51.57642, -0.12648],
  "N88EY": [51.57664, -0.13122],
  "N88JJ": [51.58511, -0.13281],
  "N88JN": [51.58228, -0.12801],
  "N88JQ": [51.58215, -0.12658],
  "N88LJ": [51.58639, -0.12349],
  "N88NH": [51.58305, -0.11915],
  "N88RE": [51.58201, -0.12821],
  "N88RG": [51.58162, -0.13151],
  "N89BT": [51.58183, -0.11996],
  "N89EA": [51.57608, -0.1219],
  "N89EG": [51.57451, -0.12174],
  "N89JA": [51.57837, -0.12154],
  "N89LP": [51.57909, -0.11246],
  "N89PP": [51.5807, -0.11591],
  "N89SN": [51.57831, -0.12352],
  "NW116EB": [51.58887, -0.18627],
  "NW116EJ": [51.58994, -0.18806],
  "NW116QS": [51.5868, -0.19225],
  "NW116QX": [51.58593, -0.19096],
  "NW117AG": [51.58143, -0.1904],
  "NW117BN": [51.58109, -0.18916],
  "NW117EN": [51.57941, -0.19725],
  "NW117HY": [51.56941, -0.18481],
  "NW117RN": [51.57221, -0.19481],
  "NW117SX": [51.56902, -0.18573],
  "NW117TP": [51.58171, -0.19738],
  "NW11LT": [51.52965, -0.13066],
  "NW11RX": [51.53278, -0.13294],
  "NW12DB": [51.52999, -0.12699],
  "NW14NR": [51.52848, -0.15123],
  "NW14RY": [51.53572, -0.15571],
  "NW17AB": [51.53664, -0.14679],
  "NW17AY": [51.5381, -0.14934],
  "NW17TH": [51.53713, -0.14822],
  "NW18EH": [51.54318, -0.15112],
  "NW18HE": [51.54416, -0.14957],
  "NW18JH": [51.54001, -0.1508],
  "NW18RU": [51.54281, -0.1446],
  "NW18TN": [51.53991, -0.15545],
  "NW18TX": [51.54087, -0.15403],
  "NW23RT": [51.55562, -0.20702],
  "NW31DN": [51.5576, -0.17822],
  "NW31HU": [51.55814, -0.17651],
  "NW31JH": [51.55926, -0.1766],
  "NW31LT": [51.55818, -0.17507],
  "NW31NH": [51.55483, -0.17217],
  "NW31TH": [51.55719, -0.16939],
  "NW32NY": [51.55418, -0.16076],
  "NW32QT": [51.55345, -0.16085],
  "NW32RR": [51.55548, -0.16821],
  "NW33AQ": [51.54174, -0.17185],
  "NW33DS": [51.54138, -0.16371],
  "NW33EU": [51.54406, -0.17237],
  "NW33HA": [51.54229, -0.17321],
  "NW33HY": [51.54433, -0.17418],
  "NW33NF": [51.54235, -0.1725],
  "NW33NG": [51.54308, -0.1724],
  "NW33NR": [51.54349, -0.17276],
  "NW34HS": [51.54642, -0.16707],
  "NW34NY": [51.54551, -0.17002],
  "NW34QP": [51.55101, -0.16656],
  "NW34XN": [51.54773, -0.16197],
  "NW35AE": [51.55099, -0.16999],
  "NW35HT": [51.54675, -0.17907],
  "NW35LF": [51.54571, -0.17731],
  "NW35SQ": [51.54625, -0.17816],
  "NW35SS": [51.54619, -0.17721],
  "NW35SX": [51.54884, -0.17742],
  "NW36DG": [51.55125, -0.18347],
  "NW36ET": [51.5512, -0.18478],
  "NW36LU": [51.54795, -0.18139],
  "NW36NP": [51.5534, -0.17584],
  "NW36XH": [51.55351, -0.18108],
  "NW37SR": [51.55736, -0.19075],
  "NW42BZ": [51.58764, -0.2201],
  "NW51HU": [51.55959, -0.14066],
  "NW51QR": [51.5593, -0.14975],
  "NW51RL": [51.55845, -0.14962],
  "NW51UJ": [51.55742, -0.13962],
  "NW52DB": [51.54599, -0.13467],
  "NW52SJ": [51.54968, -0.13281],
  "NW52TJ": [51.55044, -0.14105],
  "NW53AF": [51.54754, -0.14722],
  "NW53DU": [51.54746, -0.14466],
  "NW53HB": [51.54772, -0.15056],
  "NW54BN": [51.5522, -0.14855],
  "NW54QH": [51.55361, -0.1535],
  "NW61HY": [51.54905, -0.18948],
  "NW61JY": [51.55378, -0.19193],
  "NW71QS": [51.61898, -0.23043],
  "NW80JT": [51.53614, -0.18466],
  "NW80LH": [51.53418, -0.17701],
  "NW80NP": [51.53466, -0.1761],
  "NW86PD": [51.53366, -0.1726],
  "NW87AJ": [51.53286, -0.16822],
  "NW87NE": [51.53081, -0.16812],
  "NW87NJ": [51.53317, -0.17065],
  "NW87PY": [51.53586, -0.16406],
  "NW88QN": [51.52855, -0.17305],
  "NW89AY": [51.53216, -0.17795],
  "NW89XP": [51.53272, -0.17971],
  "SE217JH": [51.44692, -0.09434],
  "SW111HS": [51.45665, -0.17329],
  "SW111JB": [51.46403, -0.16414],
  "SW111NT": [51.46053, -0.16715],
  "SW112DA": [51.46462, -0.17955],
  "SW112NU": [51.46517, -0.17092],
  "SW112TB": [51.4688, -0.16703],
  "SW113JB": [51.47431, -0.17426],
  "SW113JS": [51.47062, -0.17206],
  "SW113RL": [51.47047, -0.17617],
  "SW114NJ": [51.47623, -0.1608],
  "SW115AP": [51.47324, -0.1595],
  "SW115QW": [51.46606, -0.15178],
  "SW115TN": [51.46516, -0.16081],
  "SW116JZ": [51.45508, -0.15879],
  "SW116PR": [51.45689, -0.16467],
  "SW116SP": [51.45425, -0.1662],
  "SW118DD": [51.48151, -0.14544],
  "SW120AB": [51.44791, -0.14475],
  "SW128DR": [51.44257, -0.1553],
  "SW128EN": [51.45115, -0.14926],
  "SW128JZ": [51.44466, -0.15546],
  "SW128SS": [51.44295, -0.16244],
  "SW129AY": [51.44318, -0.15244],
  "SW129BS": [51.44258, -0.15435],
  "SW129HE": [51.44076, -0.14818],
  "SW129SS": [51.44169, -0.15265],
  "SW130BA": [51.47007, -0.24977],
  "SW130BY": [51.47197, -0.23765],
  "SW130HG": [51.47227, -0.25057],
  "SW130HT": [51.46713, -0.24201],
  "SW130LF": [51.47228, -0.24684],
  "SW139HE": [51.47377, -0.24688],
  "SW139HL": [51.475, -0.24187],
  "SW139HQ": [51.47427, -0.24531],
  "SW139JP": [51.4859, -0.23723],
  "SW139JT": [51.4877, -0.23742],
  "SW139JW": [51.47373, -0.25044],
  "SW139LR": [51.47337, -0.2496],
  "SW139LW": [51.4736, -0.24948],
  "SW139NW": [51.48024, -0.24455],
  "SW139PY": [51.47445, -0.25057],
  "SW139QQ": [51.47626, -0.24807],
  "SW139SA": [51.4755, -0.23251],
  "SW139WT": [51.47714, -0.23572],
  "SW147AF": [51.46061, -0.27124],
  "SW147EH": [51.45813, -0.27097],
  "SW147HA": [51.46905, -0.2684],
  "SW147RT": [51.4611, -0.2756],
  "SW148AH": [51.46503, -0.26481],
  "SW148ED": [51.46496, -0.25439],
  "SW148HB": [51.46907, -0.26232],
  "SW148HE": [51.46859, -0.2612],
  "SW148LF": [51.46257, -0.26817],
  "SW148LP": [51.46577, -0.26785],
  "SW148LS": [51.46447, -0.2664],
  "SW148NU": [51.46643, -0.26311],
  "SW148QG": [51.46798, -0.25668],
  "SW148QT": [51.46493, -0.26126],
  "SW148RE": [51.45959, -0.25976],
  "SW148RG": [51.46315, -0.25771],
  "SW151BL": [51.46557, -0.23067],
  "SW151LB": [51.46992, -0.22101],
  "SW151LQ": [51.47026, -0.22581],
  "SW151PF": [51.46206, -0.21777],
  "SW151RT": [51.46118, -0.2166],
  "SW151SN": [51.46518, -0.21392],
  "SW151TW": [51.46375, -0.21676],
  "SW152JQ": [51.46537, -0.21317],
  "SW152PU": [51.46295, -0.21038],
  "SW152SH": [51.46072, -0.21581],
  "SW153PQ": [51.43647, -0.253],
  "SW153TU": [51.44873, -0.22648],
  "SW154HB": [51.45001, -0.24206],
  "SW155DA": [51.45531, -0.23741],
  "SW155EL": [51.45953, -0.23908],
  "SW155HU": [51.45905, -0.2344],
  "SW155JH": [51.46346, -0.24915],
  "SW155JP": [51.45461, -0.25549],
  "SW155JR": [51.45594, -0.2558],
  "SW155LH": [51.46482, -0.24908],
  "SW155LR": [51.46298, -0.24519],
  "SW155NX": [51.45761, -0.24194],
  "SW155PH": [51.45685, -0.24415],
  "SW155PJ": [51.45514, -0.24692],
  "SW155PU": [51.45669, -0.24309],
  "SW156BH": [51.45685, -0.21806],
  "SW161AW": [51.43476, -0.13743],
  "SW161BB": [51.43114, -0.12978],
  "SW161EQ": [51.43751, -0.12699],
  "SW161HJ": [51.42982, -0.13007],
  "SW161PN": [51.43185, -0.12899],
  "SW161RU": [51.43247, -0.13968],
  "SW162QB": [51.4336, -0.12157],
  "SW163BX": [51.42146, -0.12086],
  "SW166HP": [51.42566, -0.13129],
  "SW166HX": [51.42376, -0.13049],
  "SW170AQ": [51.43812, -0.18006],
  "SW170BB": [51.43264, -0.18826],
  "SW170NE": [51.4296, -0.17356],
  "SW170NY": [51.43687, -0.18717],
  "SW170QT": [51.42668, -0.17569],
  "SW170RG": [51.42885, -0.16747],
  "SW170RJ": [51.42815, -0.16643],
  "SW177DF": [51.4376, -0.16801],
  "SW177PP": [51.43688, -0.16424],
  "SW177TG": [51.43055, -0.16509],
  "SW178JU": [51.43488, -0.1492],
  "SW178TA": [51.42869, -0.16467],
  "SW179PP": [51.42515, -0.1614],
  "SW179SH": [51.42359, -0.16365],
  "SW181AE": [51.45941, -0.18648],
  "SW181HN": [51.45851, -0.19798],
  "SW181HS": [51.4582, -0.19797],
  "SW181PP": [51.46226, -0.20056],
  "SW181SL": [51.46026, -0.19059],
  "SW181SS": [51.4602, -0.18875],
  "SW181TG": [51.45987, -0.18874],
  "SW181TH": [51.45888, -0.19122],
  "SW182GJ": [51.45365, -0.19507],
  "SW182PP": [51.45615, -0.19005],
  "SW182PT": [51.45658, -0.1919],
  "SW182PU": [51.45737, -0.19092],
  "SW182QE": [51.45756, -0.18466],
  "SW182RS": [51.45394, -0.18775],
  "SW182SA": [51.45153, -0.18603],
  "SW183HF": [51.44138, -0.17751],
  "SW183HJ": [51.44942, -0.17443],
  "SW183JY": [51.44333, -0.1732],
  "SW183NN": [51.44421, -0.1772],
  "SW183RT": [51.45063, -0.17196],
  "SW184AQ": [51.45618, -0.19235],
  "SW184AZ": [51.45168, -0.19616],
  "SW184DN": [51.45283, -0.1927],
  "SW184EZ": [51.43999, -0.18799],
  "SW184GQ": [51.4562, -0.19673],
  "SW184JJ": [51.45723, -0.19816],
  "SW184RL": [51.44084, -0.19076],
  "SW184SR": [51.44103, -0.18679],
  "SW184TE": [51.45509, -0.19381],
  "SW184TF": [51.45457, -0.19314],
  "SW185JG": [51.44951, -0.20009],
  "SW185JH": [51.44832, -0.20149],
  "SW185JR": [51.44696, -0.20858],
  "SW185JU": [51.44507, -0.19773],
  "SW185LU": [51.44536, -0.20303],
  "SW185LY": [51.44574, -0.20039],
  "SW185UA": [51.44903, -0.20356],
  "SW191QG": [51.41918, -0.20138],
  "SW191RQ": [51.41985, -0.20291],
  "SW191RY": [51.41931, -0.19756],
  "SW191SB": [51.41971, -0.1945],
  "SW192RD": [51.41302, -0.18318],
  "SW193QH": [51.41677, -0.20799],
  "SW194AB": [51.42247, -0.21084],
  "SW194NS": [51.41867, -0.22179],
  "SW194QY": [51.4211, -0.2235],
  "SW194TT": [51.42153, -0.22615],
  "SW194UE": [51.42424, -0.22931],
  "SW194UW": [51.426, -0.23261],
  "SW195AE": [51.41689, -0.21329],
  "SW195AG": [51.43619, -0.21526],
  "SW195DX": [51.42463, -0.21671],
  "SW195EE": [51.42553, -0.21852],
  "SW195ER": [51.42744, -0.22072],
  "SW195LR": [51.44622, -0.22157],
  "SW195NH": [51.43756, -0.22316],
  "SW195NR": [51.43695, -0.23189],
  "SW195PQ": [51.43798, -0.21442],
  "SW195QH": [51.43977, -0.22067],
  "SW196AF": [51.44586, -0.22007],
  "SW196EW": [51.44319, -0.21803],
  "SW196PE": [51.44103, -0.2099],
  "SW197BP": [51.42835, -0.21243],
  "SW197HR": [51.43519, -0.20147],
  "SW197HS": [51.43444, -0.20393],
  "SW197HX": [51.43748, -0.20608],
  "SW197NB": [51.4224, -0.20791],
  "SW197NE": [51.42191, -0.20774],
  "SW197NL": [51.42137, -0.20656],
  "SW198DZ": [51.43966, -0.19735],
  "SW200AX": [51.40959, -0.2322],
  "SW200ET": [51.4183, -0.24584],
  "SW200JL": [51.40314, -0.23966],
  "SW200LW": [51.41125, -0.23104],
  "SW200QE": [51.41741, -0.23789],
  "SW200UJ": [51.40633, -0.24065],
  "SW208DN": [51.40962, -0.22597],
  "SW208EE": [51.40802, -0.21878],
  "SW208EF": [51.40901, -0.21995],
  "SW208LA": [51.41119, -0.21154],
  "SW208RQ": [51.41216, -0.22485],
  "SW208TE": [51.40767, -0.2179],
  "SW209AD": [51.40936, -0.20859],
  "SW209BA": [51.403, -0.23221],
  "SW24PA": [51.43844, -0.12757],
  "SW24TP": [51.44116, -0.12462],
  "SW40DZ": [51.46819, -0.13974],
  "SW40JG": [51.46349, -0.14139],
  "SW40QW": [51.46316, -0.14294],
  "SW40QZ": [51.46243, -0.14221],
  "SW46BX": [51.46385, -0.13505],
  "SW46DZ": [51.46636, -0.13685],
  "SW47DB": [51.46311, -0.13364],
  "SW47EX": [51.45985, -0.13121],
  "SW47SS": [51.46211, -0.13646],
  "SW47UH": [51.46295, -0.13568],
  "SW49AN": [51.45452, -0.15275],
  "SW49DE": [51.45759, -0.14504],
  "SW49ET": [51.45739, -0.14116],
  "SW49RU": [51.46202, -0.15114],
  "SW62TF": [51.47355, -0.19221],
  "SW66DX": [51.47237, -0.2178],
  "SW84BX": [51.47721, -0.14597],
  "TW105HS": [51.45184, -0.28241],
  "TW106EG": [51.46053, -0.29364],
  "TW106UZ": [51.4509, -0.29951],
  "TW107HN": [51.43891, -0.31214],
  "TW118EZ": [51.4279, -0.33219],
  "TW118HF": [51.42773, -0.33047],
  "TW118HG": [51.42737, -0.32957],
  "TW118HZ": [51.42732, -0.32746],
  "TW118NA": [51.43216, -0.33802],
  "TW118NN": [51.43287, -0.33766],
  "TW118PN": [51.42701, -0.33963],
  "TW118QZ": [51.42621, -0.33839],
  "TW119NA": [51.42112, -0.3154],
  "TW119NN": [51.42942, -0.3237],
  "TW119NU": [51.42793, -0.31892],
  "TW119PJ": [51.42323, -0.31244],
  "TW119PQ": [51.42296, -0.31295],
  "TW119RP": [51.41832, -0.31115],
  "TW11EB": [51.45519, -0.32807],
  "TW11QQ": [51.4577, -0.3219],
  "TW11RJ": [51.46497, -0.3225],
  "TW121AQ": [51.43094, -0.37415],
  "TW121DG": [51.43136, -0.36102],
  "TW121DQ": [51.42893, -0.36279],
  "TW121JQ": [51.42843, -0.35179],
  "TW121JW": [51.42909, -0.35368],
  "TW121NJ": [51.42633, -0.35661],
  "TW121NT": [51.42878, -0.35416],
  "TW121NY": [51.42758, -0.35487],
  "TW121NZ": [51.42712, -0.35497],
  "TW121RF": [51.42617, -0.3586],
  "TW122BX": [51.41394, -0.3634],
  "TW122EB": [51.41395, -0.36065],
  "TW122EJ": [51.41275, -0.35901],
  "TW122HQ": [51.4156, -0.37362],
  "TW122JB": [51.41701, -0.37472],
  "TW122ST": [51.41758, -0.35836],
  "TW123HD": [51.42865, -0.37121],
  "TW123HF": [51.42759, -0.36861],
  "TW12NL": [51.44971, -0.3159],
  "TW13BB": [51.45099, -0.31907],
  "TW13BZ": [51.44773, -0.32581],
  "TW13DW": [51.44783, -0.32213],
  "TW13DY": [51.44534, -0.32551],
  "TW13NJ": [51.44691, -0.32706],
  "TW13RR": [51.44773, -0.32846],
  "TW14QJ": [51.44321, -0.33062],
  "TW25NP": [51.43706, -0.34758],
  "TW27BA": [51.45509, -0.34008],
  "TW91AD": [51.46108, -0.30211],
  "TW91DN": [51.46226, -0.30257],
  "TW91HY": [51.46068, -0.30437],
  "TW91QJ": [51.46207, -0.3038],
  "TW91SN": [51.46028, -0.3034],
  "TW92AZ": [51.46881, -0.29525],
  "TW92NA": [51.46408, -0.30061],
  "TW92PQ": [51.4659, -0.29811],
  "TW92SF": [51.46617, -0.30374],
  "TW93AF": [51.48583, -0.29013],
  "TW93AP": [51.48524, -0.28611],
  "TW93AY": [51.48553, -0.28479],
  "TW93HJ": [51.48021, -0.28604],
  "TW93LU": [51.47429, -0.28637],
  "TW94DU": [51.48111, -0.27954],
  "W1H5TJ": [51.5187, -0.16326],
  "W41LR": [51.49518, -0.2545],
  "W41LY": [51.49596, -0.25241],
  "W41RX": [51.49356, -0.25988],
  "W42EU": [51.492, -0.25615],
  "W42JR": [51.48807, -0.25696],
  "W42SH": [51.47357, -0.25635],
  "W42SP": [51.4791, -0.25846],
  "W43DY": [51.48711, -0.26976],
  "W43UH": [51.47836, -0.26838],
  "W43UN": [51.48191, -0.25981],
  "W44JN": [51.49118, -0.26546],
  "W45DT": [51.49207, -0.26509],
  "W45DX": [51.49388, -0.26799],
  "W45RF": [51.49319, -0.26858],
  "W45RT": [51.4925, -0.27672],
  "W45TF": [51.49275, -0.2651],
  "W45UL": [51.49292, -0.26361],
  "W45YA": [51.49462, -0.27563],
  "W69LR": [51.49274, -0.23706],
  "WC1H9EL": [51.52624, -0.12696],
  "WC1H9PY": [51.52725, -0.12876],
};

export const OUTCODE_COORDS = {
  "CR4": { lat: 51.40439, lon: -0.15916, district: "Colliers Wood" },
  "E10": { lat: 51.5677, lon: -0.01439, district: "Forest" },
  "E2": { lat: 51.52964, lon: -0.06262, district: "Bethnal Green East" },
  "E8": { lat: 51.54378, lon: -0.06609, district: "Bethnal Green West" },
  "EN1": { lat: 51.6543, lon: -0.06787, district: "Bullsmoor" },
  "EN4": { lat: 51.64938, lon: -0.16004, district: "Barnet Vale" },
  "EN5": { lat: 51.65011, lon: -0.19803, district: "Barnet Vale" },
  "KT1": { lat: 51.40763, lon: -0.29828, district: "Canbury Gardens" },
  "KT2": { lat: 51.41904, lon: -0.29045, district: "Canbury Gardens" },
  "KT3": { lat: 51.39964, lon: -0.25769, district: "Coombe Hill" },
  "KT5": { lat: 51.39053, lon: -0.28674, district: "Alexandra" },
  "KT6": { lat: 51.38743, lon: -0.3028, district: "Alexandra" },
  "KT7": { lat: 51.38802, lon: -0.33407, district: "Hinchley Wood and Weston Green" },
  "KT9": { lat: 51.36385, lon: -0.3032, district: "Chessington South & Malden Rushett" },
  "N1": { lat: 51.53777, lon: -0.09698, district: "Barnsbury" },
  "N10": { lat: 51.59495, lon: -0.14522, district: "Alexandra Park" },
  "N11": { lat: 51.61371, lon: -0.13894, district: "Alexandra Park" },
  "N12": { lat: 51.6149, lon: -0.17762, district: "Friern Barnet" },
  "N13": { lat: 51.61805, lon: -0.10423, district: "Arnos Grove" },
  "N14": { lat: 51.63442, lon: -0.13093, district: "Arnos Grove" },
  "N15": { lat: 51.58279, lon: -0.08098, district: "Harringay" },
  "N16": { lat: 51.56252, lon: -0.07663, district: "Cazenove" },
  "N1C": { lat: 51.53693, lon: -0.1259, district: "Camden Square" },
  "N2": { lat: 51.59009, lon: -0.16928, district: "East Finchley" },
  "N20": { lat: 51.62925, lon: -0.17431, district: "Barnet Vale" },
  "N21": { lat: 51.63673, lon: -0.09967, district: "Bush Hill Park" },
  "N22": { lat: 51.59979, lon: -0.11019, district: "Alexandra Park" },
  "N3": { lat: 51.60014, lon: -0.19383, district: "Finchley Church End" },
  "N4": { lat: 51.57011, lon: -0.10375, district: "Arsenal" },
  "N5": { lat: 51.5539, lon: -0.09854, district: "Arsenal" },
  "N6": { lat: 51.57323, lon: -0.1462, district: "Crouch End" },
  "N7": { lat: 51.55334, lon: -0.11829, district: "Arsenal" },
  "N8": { lat: 51.58313, lon: -0.11974, district: "Crouch End" },
  "NW1": { lat: 51.53341, lon: -0.14385, district: "Bloomsbury" },
  "NW11": { lat: 51.57837, lon: -0.19741, district: "Childs Hill" },
  "NW2": { lat: 51.55832, lon: -0.22014, district: "Brondesbury Park" },
  "NW3": { lat: 51.55235, lon: -0.17254, district: "Belsize" },
  "NW4": { lat: 51.58735, lon: -0.22424, district: "Colindale South" },
  "NW5": { lat: 51.55173, lon: -0.14511, district: "Gospel Oak" },
  "NW6": { lat: 51.54219, lon: -0.19623, district: "Abbey Road" },
  "NW7": { lat: 51.61468, lon: -0.23374, district: "Burnt Oak" },
  "NW8": { lat: 51.53218, lon: -0.17432, district: "Abbey Road" },
  "SE21": { lat: 51.43897, lon: -0.08873, district: "Dulwich Village" },
  "SW11": { lat: 51.46875, lon: -0.16284, district: "Balham" },
  "SW12": { lat: 51.44632, lon: -0.14906, district: "Balham" },
  "SW13": { lat: 51.47631, lon: -0.24319, district: "Barnes" },
  "SW14": { lat: 51.46538, lon: -0.267, district: "East Sheen" },
  "SW15": { lat: 51.45695, lon: -0.22862, district: "Coombe Hill" },
  "SW16": { lat: 51.42123, lon: -0.12925, district: "Bensham Manor" },
  "SW17": { lat: 51.43103, lon: -0.16525, district: "Colliers Wood" },
  "SW18": { lat: 51.45152, lon: -0.19145, district: "East Putney" },
  "SW19": { lat: 51.42417, lon: -0.20281, district: "Abbey" },
  "SW2": { lat: 51.44929, lon: -0.11979, district: "Brixton Acre Lane" },
  "SW20": { lat: 51.41079, lon: -0.22786, district: "Cannon Hill" },
  "SW4": { lat: 51.46098, lon: -0.13647, district: "Balham" },
  "SW6": { lat: 51.47657, lon: -0.20098, district: "Fulham Reach" },
  "SW8": { lat: 51.47679, lon: -0.13197, district: "Battersea Park" },
  "TW1": { lat: 51.45102, lon: -0.32538, district: "Isleworth" },
  "TW10": { lat: 51.44773, lon: -0.30288, district: "East Sheen" },
  "TW11": { lat: 51.42629, lon: -0.33178, district: "Fulwell & Hampton Hill" },
  "TW12": { lat: 51.42296, lon: -0.36973, district: "Fulwell & Hampton Hill" },
  "TW2": { lat: 51.44632, lon: -0.35454, district: "Fulwell & Hampton Hill" },
  "TW9": { lat: 51.46961, lon: -0.29238, district: "Kew" },
  "W1H": { lat: 51.5177, lon: -0.16121, district: "Marylebone" },
  "W4": { lat: 51.49118, lon: -0.26409, district: "Chiswick Gunnersbury" },
  "W6": { lat: 51.49256, lon: -0.22844, district: "Addison" },
  "WC1H": { lat: 51.52686, lon: -0.12568, district: "Bloomsbury" },
};
